import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { AppState } from './app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalRef, GlobalVariables } from '../common/global-variables';
import { VcaAlertsService } from '../common/vca-alerts';
import { AuthService } from './auth/auth.service';
import { AUTH_CONSTANTS } from './auth/auth-constants';
import { JobsPollingService } from './services/job-poller.service';
import { LicenseAlertService } from './services/license-alert.service';
import { RefreshSharedService } from './refresh-shared-service';
import { JobsNotifierService } from './services/job-notifier.service';
import { AlarmsPollingService } from './services/alarm-poller.service';
import { NspUpgradeService } from './../publisher/src/publisher-ui/upgrade/nsp-upgrade.service';
import { HybridInterconnectService } from './components/hybrid-interconnect/hybrid-interconnect.service';
import { Router } from '@angular/router';
import { ToastNotifierService } from './services/toast-notifier.service';
import { checkIfUserHasRoles } from '../common/utils/utils';
import { ICCService } from './components/administration-main/interconnect-configuration/icc.service';
const _ = require('lodash');
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import {environment} from '../environments/environment';

import 'rxjs/add/operator/map';
import { FeatureEnablementService } from './services/feature-enablement.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./app.scss',
    './components/dataprotection/dataprotection-vcd/dataprotection-vcd.scss',
    './components/compute/compute-vcd/compute-vcd.scss',
    './components/dashboard/dashboard.scss',
    './components/dataprotection/dataprotection-vc/dataprotection-vc.scss'],
    templateUrl: './app.html'
})
export class App implements AfterViewInit {

    public authConstants = AUTH_CONSTANTS;
    private loggingSubscriber;
    private rsService: RefreshSharedService;
    private jobPollerSubscription: any;
    private alarmPollerSubscription: any;
    public windowData: any;
    private router: Router;
    private disableAdmininstratorView: boolean = false;
    private isVCDGVRDepricated: boolean = false;
    private licenseConnAlert: string = 'license-connectivity';
    private interconnectSubscription: any;
    private showServices: boolean = true;
    private endpointType = null;
    private isVCEnvironment = false;
    // private isLoading = true;
    private disableLegacyInterconnectConfiguration: boolean = false;
    private disableDeploymentContainers: boolean = true;
    private isSystemAdmin = false;
    private extendedNetworksUi2: boolean = false;
    private isNSX_T : boolean = false;
    public loadedInVCRemotePlugin = false;

    constructor(public appState: AppState,
                public authService: AuthService,
                public jobPoller: JobsPollingService,
                public vcaAlertsService: VcaAlertsService,
                public licenseAlertService: LicenseAlertService,
                private translate: TranslateService,
                private rss: RefreshSharedService,
                private jobNotifierService: JobsNotifierService, _global: GlobalRef,
                public alarmPoller: AlarmsPollingService,
                public nspUpgradeSvc: NspUpgradeService,
                public toastNotifierService: ToastNotifierService, // to trigger toast notifications
                private iccService: ICCService,
                private hybridInterconnectService: HybridInterconnectService,
                private featureEnablementService: FeatureEnablementService,
                _router: Router,
                public datepipe: DatePipe) {
        if (_global.nativeGlobal['DATA']) {
            this.windowData = _global.nativeGlobal['DATA'];
        }
        this.initializeTranslations();
        this.loggingSubscriber = this.authService.getAuthChangeEvent().subscribe((res) => {
            this.loadedInVCRemotePlugin = environment.loadedInVCRemotePlugin;
            if (res === 'LOGIN_COMPLETE') {
                console.info('LOGIN_COMPLETE');
                const me = this;

                this.nspUpgradeSvc.queryHcmInstances(
                    () => setTimeout(() =>{
                        me.initApplication();
                        me.getNsxConfig();
                    }, 10),
                    null);

                this.jobPoller.startJobPoller();
                this.validateLicenseActivation();

                // isVCDGVRDepricated variable will be used to control visibility of top menu items Dashboard and Inventory
                this.isVCDGVRDepricated = this.authService.isVCDGVRDepricated;
                const roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
                if ( checkIfUserHasRoles(roles) ) {
                    if (this.isVCDGVRDepricated && _.includes(roles, 'Organization Administrator')) {
                        // Orgadmin should not see "Administration tab if it is newVCDGVR
                        this.disableAdmininstratorView = true;
                    } else {
                        this.disableAdmininstratorView = false;
                    }

                    // For new GVR, start alarm poller
                    if (!(this.isVCDGVRDepricated && _.includes(roles, 'Organization Administrator'))) {
                        this.alarmPoller.startAlarmPoller();
                    }
                    if (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VIO) {
                        if (_.includes(roles, AUTH_CONSTANTS.SysAdmin)) {
                            this.disableAdmininstratorView = false;
                            this.showServices = false;
                        } else if (_.includes(roles, AUTH_CONSTANTS.OrgAdmin)) {
                            this.disableAdmininstratorView = true;
                            this.showServices = true;
                        }
                    }
                } else {
                    this.disableAdmininstratorView = true;
                }

                // Show bundles should be called for old GVR no matter the user.
                // For new GVR, only for Org Admin, this should not be called.
                if (!(this.isVCDGVRDepricated && _.includes(roles, 'Organization Administrator'))) {
                    this.showBundles(res);
                }

                if (this.isVCDGVRDepricated) {
                    // services tab should be shown only to Organization administrator.
                    this.showServices = _.includes(roles, 'Organization Administrator');
                }
                // Display applevel alert only for VC type and for users with role System Administrator
                this.checkAdminMessages();

            } else if (res === 'LOGOUT_TRIGGERED') {
                console.info('App: loggingSubscriber: LOGOUT_TRIGGERED');
                sessionStorage.removeItem('hcx-license-data');
                this.jobPoller.endJobPoller();
                this.alarmPoller.endAlarmPoller();
                this.showBundles(res);
                //this.isInterconnectConfigured = true;
            } else {
                console.info(res);
            }
        },
            (error) => { console.error(error); },
            () => { }
        );
        this.rsService = rss;
        this.router = _router;
    }

    public initializeTranslations() {
        let userLang = navigator.language.split('-')[0];
        userLang = GlobalVariables.SUPPORTED_LOCALES.indexOf(userLang) !== -1 ? userLang : 'en';
        GlobalVariables.LOCALE = userLang;
        this.translate.setDefaultLang('en');
        this.translate.use(userLang);
   }

    public ngOnInit() {
        console.info('App ngOnInit');
        this.bindEvent(window, 'message', (event) => {
            if ( event.data === 'showSystemUpdateApp' ) {
                // console.log('received message:' + event.data);
                this.router.navigate(['./upgradeapp']);
            }
        });

        this.jobPollerSubscription = this.jobNotifierService.getCompletedJobs().subscribe(
            (jobs) => {
                this.handleJobs(jobs);
            }, (error) => { console.error(error); },
            () => {}
        );
    }

    private bindEvent(element, eventName, eventHandler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, eventHandler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler);
        }
    }
    private getNsxConfig(){
        const localEndpoint = this.nspUpgradeSvc.getLocalHcmReference();
        localEndpoint && this.featureEnablementService.getNsxConfig(localEndpoint.resourceId).subscribe((res)=>{
            this.isNSX_T =  res && Array.isArray(res) && res.length > 0 && res[0].config && res[0].config.type.toLowerCase()==='nsx-t'? true : false;
        })
    }

    private initApplication() {
        const localEndpoint = this.nspUpgradeSvc.getLocalHcmReference();
        this.endpointType = localEndpoint != null ? localEndpoint.endpoint != null ? localEndpoint.endpoint.endpointType : null : null;

        if (this.authService.VREALM_TYPE === AUTH_CONSTANTS.VCD) {
            this.isVCEnvironment = false;
        } else {
             this.isVCEnvironment = true;
        }

        if ( this.endpointType === 'hcm') {
            document.title = 'VMware HCX';
        } else {
            document.title = 'VMware HCX';
        }

        const roles = (this.authService.loggedInUserInfo && this.authService.loggedInUserInfo.roles) ? this.authService.loggedInUserInfo.roles : [];
        if (_.includes(roles, 'System Administrator')) {
            this.isSystemAdmin = true;
        }

        this.featureEnablementService.getFeatureEnablement(localEndpoint.resourceId, {feature: 'EXTENDED_NETWORKS_UI_2'}).subscribe((result:any) => {
            if (result.errors && result.errors.length > 0) {
                let errorMessage: string = '';
                for (const error of result.errors) {
                    errorMessage = errorMessage.concat(errorMessage, error.text);
                    console.log(errorMessage);
                }
                console.error(JSON.stringify(errorMessage));
            } else {
                if (!!result && result.operations.length > 0) {
                    this.extendedNetworksUi2 = true;
                    console.log('New Extended Networks UI is activated');
                } else {
                    console.log('New Extended Networks UI is deactivated');
                }
            }
        }, (error) => {
            console.error('Error calling feature enablement API:', error);
        });

       // this.isLoading = false;
    }

    public showBundles(res) {
        if (res === 'LOGOUT_TRIGGERED') {
            console.log('showBundles:  LOGOUT_TRIGGERED');
            this.windowData.upgradeAlert = false;
            this.windowData.adminMessageAlert = false;
        } else {
            this.checkBundles();
        }
    }

    public checkBundles(successCb?: any, errorCb?: any) {
        const me = this;
        me.windowData.upgradeAlert = false;
        me.nspUpgradeSvc.loadAllNspUpgradeData();
        me.nspUpgradeSvc.nspData.subscribe(
            (value) => {
                if (value.length) {
                    for (let i = 0; i < value.length; i++) {
                        if (value[i]['availableBundles'].length > 0) {
                            me.windowData.upgradeAlert = true;
                            if (successCb) {
                                successCb.call(me, me.windowData.upgradeAlert);
                                return;
                            }
                        }
                    }
                }
            },
            (error) => {
                console.log(error);
                if (errorCb) {
                    errorCb.call(me, error);
                }
            },
            () => { }
        );
    }

    /// Admin Messages
    private adminMessageDescription: string = '';
    private showAdminMsg: boolean = false;
    private bundleWarning: string = 'alert-warning';
    private adminSeverity = 'alert-warning';
    private adminMessageCount: any = 0;
    private adminMessageTimer: any;

    public networkConnectBanner: boolean;
    private bannerTimer: any;
    private licenseExpiryDate: string;

    public checkAdminMessages() {

        const me = this;

        me.windowData.adminMessageAlert = false;
        me.windowData.adminMessageAlerts = [];
        me.windowData.adminMessageContent = '';
        me.nspUpgradeSvc.pollAdministrationMessages().subscribe(
            (response: any) => {
                if (response.success) {
                    me.windowData.adminMessageAlerts = response.data.messages;
                    me.windowData.adminMessageContent = response.data.messages;
                    if (me.windowData.adminMessageContent.length > 0) {
                        me.windowData.adminMessageAlert = true;
                        me.displayAdminMessageCollection();
                    }
                }
                if (response.errors) {
                    console.log(response.errors);
                    // TODO: let user top know....
                }
            },
            (error) => {
                console.log(error);
            },
            () => { }
        );
    }
    public displayAdminMessageCollection() {
        const me = this;
        me.showAdminMsg = true; // !me.showAdminMsg;
        me.adminMessageDescription = me.windowData.adminMessageAlerts[0].adminMessage.subject + ' ' +
            me.windowData.adminMessageAlerts[0].adminMessage.content;
        const obj = me.windowData.adminMessageAlerts[0];
        me.showAdminMessage(me);
    }

    public showAdminMessage(msg) {

        const me = this;
        const severityColorCode = '';
        let upgrade = false;
        if (msg.hasOwnProperty('windowData') && msg.windowData.adminMessageAlerts.length > 0) {
            msg.windowData.adminMessageAlerts.forEach((el, idx) => {
                if ((el['adminMessage'].subject || '').toLowerCase().includes('software update')) {
                    upgrade = true;
                    msg.adminMessageDescription = msg.windowData.adminMessageAlerts[idx].adminMessage.subject + ' ' + msg.windowData.adminMessageAlerts[idx].adminMessage.content;
                    msg = msg.windowData.adminMessageAlerts[idx];
                    this.adminMessageCount = idx;
                }
            })
            if (!upgrade) {
                msg.adminMessageDescription = msg.windowData.adminMessageAlerts[0].adminMessage.subject + ' ' + msg.windowData.adminMessageAlerts[0].adminMessage.content;
                msg = msg.windowData.adminMessageAlerts[0];
            }
        }

        switch (msg.adminMessage.severity) {
            case 'EXTREME':
                me.bundleWarning = 'alert-danger';
                me.adminMessageDescription = msg.adminMessage.subject + ' : ' + msg.adminMessage.content;
                me.showAdminMsg = true;
                clearTimeout(me.adminMessageTimer);
                me.adminMessageTimer = setTimeout(function () {
                    if (me.windowData.upgradeAlert) {
                        //    me.adminMessageDescription = me.adminMessageDescription;;
                        me.bundleWarning = 'alert-warning';
                        me.showAdminMsg = false;
                    }
                }, 30000);
                break;
            case 'MINOR':
                me.bundleWarning = 'alert-success';
                me.adminMessageDescription = msg.adminMessage.subject + ' : ' + msg.adminMessage.content;
                me.showAdminMsg = true;
                clearTimeout(me.adminMessageTimer);
                me.adminMessageTimer = setTimeout(function () {
                    if (me.windowData.upgradeAlert) {
                        //    me.adminMessageDescription = me.adminMessageDescription;;
                        me.bundleWarning = 'alert-warning';
                        me.showAdminMsg = false;
                    }
                }, 30000);
                break;
            case 'MODERATE':
                me.bundleWarning = 'alert-info';
                me.adminMessageDescription = msg.adminMessage.subject + ' : ' + msg.adminMessage.content;
                me.showAdminMsg = true;
                clearTimeout(me.adminMessageTimer);
                me.adminMessageTimer = setTimeout(function () {
                    if (me.windowData.upgradeAlert) {
                        //    me.adminMessageDescription = me.adminMessageDescription;;
                        me.bundleWarning = 'alert-warning';
                        me.showAdminMsg = false;
                    }
                }, 30000);
                break;
            case 'SEVERE':
                me.bundleWarning = 'alert-warning';
                me.adminMessageDescription = msg.adminMessage.subject + ' : ' + msg.adminMessage.content;
                me.showAdminMsg = true;
                clearTimeout(me.adminMessageTimer);
                me.adminMessageTimer = setTimeout(function () {
                    if (me.windowData.upgradeAlert) {
                        //    me.adminMessageDescription = me.adminMessageDescription;
                        me.bundleWarning = 'alert-warning';
                        me.showAdminMsg = false;
                    }
                }, 3000);
                break;
            default:
                break;
        }
    }

    public scanMessages(adminMsg, e) {
        const me = this;
        if (e.currentTarget.id === 'nextMsg') {
            me.adminMessageCount++;
            if (me.adminMessageCount === me.windowData.adminMessageAlerts.length) {
                //
                me.adminMessageCount = 0;
                me.showAdminMessage(me.windowData.adminMessageAlerts[me.adminMessageCount]);
             } else if (me.adminMessageCount < (me.windowData.adminMessageAlerts.length )) {
                me.showAdminMessage(me.windowData.adminMessageAlerts[me.adminMessageCount]);
            }
        } else if (e.currentTarget.id === 'leftMsg') {
            me.adminMessageCount--;
            if (me.adminMessageCount < 0) {
                me.adminMessageCount = me.windowData.adminMessageAlerts.length - 1;
                me.showAdminMessage(me.windowData.adminMessageAlerts[me.adminMessageCount]);
            } else {
                me.showAdminMessage(me.windowData.adminMessageAlerts[me.adminMessageCount]);
            }
        }
    }

    ////
    public ngAfterViewInit() {

    }

    public validateLicenseActivation() {
        // check license activation status
        this.licenseAlertService.getLicenseActivationStatus().subscribe(
            (resp: any) => {
                sessionStorage.setItem('hcx-license-data', JSON.stringify(resp));
                if (!resp.data.activationDone) {
                    if (!!resp.data.moreInfo && !resp.data.moreInfo.isGraceExpired) {
                        // TODO: Externalise this message
                        // Show alert on to activate services
                        this.licenseExpiryDate = this.datepipe.transform(new Date(resp.data.moreInfo.expiryTimeInMillis), 'mediumDate');
                        this.vcaAlertsService.warning(`HCX is currently in evaluation mode and expires on ${this.licenseExpiryDate}. You must enter a valid license key.`
                        , this.licenseConnAlert);
                    } else {
                        // TODO: Externalise this message
                        // Show alert on license expired
                        this.vcaAlertsService.danger('HCX functionality is restricted. Renew the expired licenses to continue using HCX services.'
                        , this.licenseConnAlert);
                    }
                } else {
                    // Check for HCX Connectivity loss
                    if (this.isFlagPresentAndTrue(resp['data'].hasCommunicationBroken)) {
                        // TODO: Externalise this message
                        // show alert on Communication to HCX is broken
                        this.vcaAlertsService.danger('The HCX service is disconnected. Restore your connection to the HCX service to proceed.'
                        , this.licenseConnAlert);
                    } else { // Check if Communication broken warning is present
                        if (this.isFlagPresentAndTrue(resp['data'].warnCommunicationBroken)) {
                            this.vcaAlertsService.warning('Unable to communicate with the HCX service'
                            , this.licenseConnAlert);
                        }
                    }
                }
            },
            (error) => {
                sessionStorage.setItem('hcx-license-data', null);
                console.log(error);
            },
            () => { }
        );
    }

    public isFlagPresentAndTrue(flagName) {
        return (!!flagName && flagName);
    }

    public handleJobs(jobs) {
        if (this.rsService.shouldRefreshPage(jobs)) {
            this.rsService.refresh('jobPoller');
        }
    }

    public refreshPage() {
        this.rsService.refresh('refreshIcon');
    }

    public logout() {
        // tslint:disable-next-line:no-empty
        this.authService.logout(); // .subscribe(() => {} );
    }

    public ngOnDestroy() {
        if (this.jobPollerSubscription) {
            this.jobPollerSubscription.unsubscribe();
        }
        if (this.alarmPollerSubscription) {
            this.alarmPollerSubscription.unsubscribe();
        }
        if (this.interconnectSubscription) {
            this.interconnectSubscription.unsubscribe();
        }
    }

    public loadInventory() {
        const loc = location.href;
        if (loc.indexOf('/inventory') === -1) {
            this.router.navigate(['./inventory']);
        }
    }

    public openLink(url) {
        const win = window.open(url, '_blank');
        win.focus();
    }

    // TODO update to use featureConfig API - This is only for DEMO of HCX Onprem SA 2/2019
    private isFeatureEnabled(feature: string, operation: string): boolean {
        if (feature === 'GVR_DASHBOARD_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'nsp' && !this.isVCDGVRDepricated && this.authService.VREALM_TYPE !== this.authConstants.VIO;
            }
        } else if (feature === 'HCSP_DASHBOARD_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'hcm';
            }
        } else if (feature === 'DESIGNER_VIEW') {
            if (operation === 'VISIBLE') {
                return false;
            }
        } else if (feature === 'COMPUTE_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'nsp' && !this.isVCDGVRDepricated && this.authService.VREALM_TYPE !== this.authConstants.VIO;
            }
        } else if ((feature === 'NETWORKING_VIEW') && !this.isNSX_T) {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'nsp' && this.isVCEnvironment && this.authService.VREALM_TYPE !== this.authConstants.VIO;
            }
        } else if (feature === 'DATA_PROTECTION_VIEW') {
            if (operation === 'VISIBLE') {
                return false;
            }
        } else if (feature === 'NETWORKS_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'nsp' && !this.isVCEnvironment && !this.isVCDGVRDepricated;
            }
        } else if (feature === 'MIGRATION_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'hcm' || (this.endpointType === 'nsp' && this.authService.VREALM_TYPE === this.authConstants.VC);
            }
        } else if (feature === 'DISASTER_RECOVERY_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'hcm' || this.endpointType === 'nsp';
            }
        } else if (feature === 'NETWORK_EXTENSION_VIEW') {
            if (operation === 'VISIBLE') {
                return (this.endpointType === 'hcm' || (this.endpointType === 'nsp' && (this.authService.VREALM_TYPE === this.authConstants.VC || this.authService.VREALM_TYPE === this.authConstants.VCD))) && !(this.isVCDGVRDepricated && this.isSystemAdmin);
            }
        } else if (feature === 'NETWORK_EXTENSION_VIEW2') {
            if (operation === 'VISIBLE') {
                return this.extendedNetworksUi2 && (this.endpointType === 'hcm' || (this.endpointType === 'nsp' && this.authService.VREALM_TYPE === this.authConstants.VC)) && !(this.isVCDGVRDepricated && this.isSystemAdmin);
            }
         } else if (feature === 'DEPLOYMENT_CONTAINERS_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'nsp' && this.isVCEnvironment && !this.disableDeploymentContainers;
            }
        } else if (feature === 'IX_CONFIG_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'nsp' && this.isVCEnvironment &&
                    !this.disableLegacyInterconnectConfiguration  && this.authService.VREALM_TYPE !== this.authConstants.VIO;
            }
        } else if (feature === 'INVENTORY_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'nsp' && this.authService.VREALM_TYPE === this.authConstants.VCD && !this.isVCDGVRDepricated;
            }
        } else if (feature === 'SITE_PAIRING_VIEW') {
            if (operation === 'VISIBLE') {
                // only show this tab if its standalone hcm or nsp for VC
                return this.endpointType === 'hcm' || (this.endpointType === 'nsp' && this.authService.VREALM_TYPE === this.authConstants.VC);
            }
        }

        return false;
    }

    // tslint:disable-next-line:member-ordering
    public loadServices() {
        this.router.navigate(['./services/network-extension-embed']);
      }

      public getHcxDocs() {
        const docsLink = 'https://docs.vmware.com/en/VMware-HCX/services/rn/VMware-HCX-Release-Notes.html';
        window.open(docsLink);
      }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts